// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from "react";
import { useRegion } from "../context/RegionContext";
import { useNavigate } from "react-router-dom";
import "./Checkout.css";
import paymentService from "./paymentService";
import { API_ENDPOINTS } from "../config/api";
import axios from "axios";
import { getCartFromStorage, clearCart, getCouponsFromStorage } from "./cartUtils";



export default function Checkout() {
    const navigate = useNavigate();
    const [cartItems, setCartItems] = useState([]);
    const [currentStep, setCurrentStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [step2Loading, setStep2Loading] = useState(false);
    const [step3Loading, setStep3Loading] = useState(false);
    
    // Form states
    const [requireLogin, setRequireLogin] = useState(true);
    const [userEmail, setUserEmail] = useState("");
    const [countryCode, setCountryCode] = useState("+91");
    const [contactNumber, setContactNumber] = useState("");
    const [billingAddress, setBillingAddress] = useState({
        name: "",
        street: "",
        city: "",
        state: "",
        zip: "",
        country: "India"
    });
    const [paymentMethod, setPaymentMethod] = useState("UPI");
    
    const [appliedCoupons, setAppliedCoupons] = useState([]);
    const { selectedCountry, regions } = useRegion();
    
    // User authentication states
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userData, setUserData] = useState(null);
    const [emailChecked, setEmailChecked] = useState(false);
    const [userExists, setUserExists] = useState(false);
    const [password, setPassword] = useState("");
    const [authError, setAuthError] = useState("");
    const [authLoading, setAuthLoading] = useState(false);
    
    useEffect(() => {
        // Check if this is a buy now flow
        const urlParams = new URLSearchParams(window.location.search);
        const isBuyNow = urlParams.get('buyNow') === 'true';
        
        const loadAndSyncCart = async () => {
            let items = [];
            if (isBuyNow) {
                // Handle buy now flow
                const buyNowOrder = sessionStorage.getItem('buyNowOrder');
                if (buyNowOrder) {
                    const orderData = JSON.parse(buyNowOrder);
                    items = orderData.products;
                    setUserEmail(orderData.email || "");
                    setContactNumber(orderData.contactNumber || "");
                    if (orderData.shippingAddress) {
                        setBillingAddress(orderData.shippingAddress);
                    }
                    // Clear the buy now order from session storage
                    sessionStorage.removeItem('buyNowOrder');
                } else {
                    navigate('/cart');
                    return;
                }
            } else {
                // Regular cart checkout flow
                const cart = getCartFromStorage();
                if (cart.length === 0) {
                    navigate('/cart');
                    return;
                }
                items = cart;
            }

            setCartItems(items);

            // Sync prices with backend
            if (items.length > 0) {
                try {
                    const syncPromises = items.map(async (item) => {
                        const productId = item.productId || (item.id && item.id.split('_')[0]);
                        if (!productId) return item;

                        const countryParam = `country=${selectedCountry || 'IN'}`;
                        let updatedProduct = null;

                        // 1. Try fetching by ID
                        try {
                            const response = await fetch(`${API_ENDPOINTS.STORE.PRODUCTS}/${productId}?${countryParam}`);
                            const rawText = await response.text();
                            const trimmed = rawText ? rawText.trim() : '';
                            if (trimmed && trimmed !== 'undefined' && trimmed !== 'null') {
                                const data = JSON.parse(trimmed);
                                if (data.success && data.data) {
                                    updatedProduct = data.data;
                                }
                            }
                        } catch (e) {
                            console.warn(`ID sync failed for ${productId}`, e);
                        }

                        // 2. Fallback to Slug if ID failed (Product might have been recreated)
                        if (!updatedProduct && item.slug) {
                            try {
                                const slugResponse = await fetch(`${API_ENDPOINTS.STORE.PRODUCTS}?slug=${item.slug}&${countryParam}`);
                                const slugRaw = await slugResponse.text();
                                const slugTrimmed = slugRaw ? slugRaw.trim() : '';
                                const slugData = (slugTrimmed && slugTrimmed !== 'undefined' && slugTrimmed !== 'null') ? JSON.parse(slugTrimmed) : {};
                                if (slugData.success && slugData.data && slugData.data.length > 0) {
                                    updatedProduct = slugData.data[0];
                                }
                            } catch (e) {
                                console.warn(`Slug sync failed for ${item.slug}`, e);
                            }
                        }

                        if (updatedProduct) {
                            return {
                                ...item,
                                productId: updatedProduct._id, // Update to current ID if changed
                                title: updatedProduct.title,
                                price: updatedProduct.offerPrice || updatedProduct.price,
                                currency: updatedProduct.currency,
                                currencySymbol: updatedProduct.currencySymbol,
                                slug: updatedProduct.slug,
                            };
                        }
                        return item;
                    });

                    const updatedItems = await Promise.all(syncPromises);
                    setCartItems(updatedItems);
                    // Also update localStorage for consistency
                    if (!isBuyNow) {
                        localStorage.setItem('cart', JSON.stringify(updatedItems));
                    }
                } catch (error) {
                    console.error('Failed to sync checkout prices:', error);
                }
            }
        };

        loadAndSyncCart();
        
        // Check if user is already logged in
        const user = localStorage.getItem('user');
        if (user) {
            const userData = JSON.parse(user);
            setIsLoggedIn(true);
            setUserData(userData);
            setUserEmail(userData.email || "");
            if (userData.name) {
                setBillingAddress(prev => ({ ...prev, name: userData.name }));
            }
            // Skip to step 2 if user is already logged in
            setCurrentStep(2);
        }

        // Load coupons from storage
        const coupons = getCouponsFromStorage();
        setAppliedCoupons(coupons);
        
    }, [navigate, selectedCountry]);

    const getMinOrderValue = (coupon) => {
        if (selectedCountry && coupon.minimumOrderValueByCountry && Array.isArray(coupon.minimumOrderValueByCountry)) {
            const countryMin = coupon.minimumOrderValueByCountry.find(c => c.countryCode === selectedCountry);
            if (countryMin) return countryMin.amount;
        }
        return coupon.minimumOrderValue || 0;
    };



    const calculateSubtotal = () => {
        return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
    };

    const calculateDiscount = () => {
        let totalDiscount = 0;
        const subtotal = calculateSubtotal();
        
        appliedCoupons.forEach(coupon => {
            // Region check - ensure coupon is applicable to current country
            if (coupon.discountByCountry && Array.isArray(coupon.discountByCountry) && coupon.discountByCountry.length > 0) {
                const isApplicable = coupon.discountByCountry.some(c => c.countryCode === selectedCountry);
                if (!isApplicable) return;
            }

            // value check - if subtotal is less than minimum order value, skip this coupon
            const minOrder = getMinOrderValue(coupon);
            if (minOrder && subtotal < minOrder) {
                return;
            }

            // Determine discount type: support both new (discountType) and old (couponType) schemas
            const isPercent = coupon.discountType 
                ? coupon.discountType === 'PERCENT' 
                : coupon.couponType === true;
            
            // Get discount value based on type
            const getDiscountValue = () => {
                if (isPercent) {
                    return coupon.discountValue || coupon.offerValue || 0;
                } else {
                    if (coupon.discountByCountry && Array.isArray(coupon.discountByCountry) && coupon.discountByCountry.length > 0) {
                        const countryDiscount = coupon.discountByCountry.find(c => c.countryCode === selectedCountry);
                        if (countryDiscount) return countryDiscount.amount;
                        
                        return coupon.discountByCountry[0].amount || 0;
                    }
                    return coupon.offerValue || 0;
                }
            };
            
            const discountVal = getDiscountValue();

            if (coupon.appliesToAll) {
                if (isPercent) {
                    totalDiscount += (subtotal * discountVal) / 100;
                } else {
                    totalDiscount += discountVal;
                }
            } else {
                coupon.applicableProducts.forEach(product => {
                    const productId = product && typeof product === 'object' && product._id 
                        ? String(product._id) 
                        : String(product);
                    
                    const cartItem = cartItems.find(item => {
                        const itemProductId = String(item.productId || item._id || item.id);
                        return itemProductId === productId;
                    });
                    
                    if (cartItem) {
                        const itemTotal = cartItem.price * cartItem.quantity;
                        if (isPercent) {
                            totalDiscount += (itemTotal * discountVal) / 100;
                        } else {
                            totalDiscount += discountVal * cartItem.quantity;
                        }
                    }
                });
            }
        });
        
        return Math.min(totalDiscount, subtotal);
    };

    const calculateTotal = () => {
        const subtotal = calculateSubtotal();
        const discount = calculateDiscount();
        return Math.max(0, subtotal - discount);
    };

    const checkEmailExists = async () => {
        if (!userEmail.trim()) return;
        
        try {
            setAuthLoading(true);
            setAuthError("");
            const res = await axios.post(
                API_ENDPOINTS.AUTH.CHECK_EMAIL,
                { email: userEmail }
            );
            setUserExists(res.data.exists);
            setEmailChecked(true);
        } catch (err) {
            console.error("Check email error", err);
            setAuthError("Something went wrong checking email. Please try again.");
        } finally {
            setAuthLoading(false);
        }
    };

    const handleAuthSubmit = async (e) => {
        e.preventDefault();
        if (!password.trim()) return;

        try {
            setAuthLoading(true);
            setAuthError("");
            let res;

            if (userExists) {
                // Login
                res = await axios.post(
                    API_ENDPOINTS.AUTH.LOGIN,
                    { email: userEmail, password },
                    {
                        timeout: 20000, // 20 second timeout
                        withCredentials: true
                    }
                );
            } else {
                // Register
                res = await axios.post(
                    API_ENDPOINTS.AUTH.REGISTER,
                    { email: userEmail, password, name: billingAddress.name },
                    {
                        timeout: 20000, // 20 second timeout
                        withCredentials: true
                    }
                );
            }

            const data = res.data;
            localStorage.setItem("token", data.token);
            localStorage.setItem("user", JSON.stringify(data.user));

            setIsLoggedIn(true);
            setUserData(data.user);
            setCurrentStep(2);
        } catch (err) {
            console.error("Auth Error:", err);
            
            // Handle different types of errors
            let errorMsg = "Authentication failed. Please try again.";
            
            if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
                errorMsg = "Request timed out. The server may be slow or unavailable. Please try again.";
            } else if (err.message === 'Network Error' || err.code === 'ERR_NETWORK') {
                errorMsg = "Network error: Unable to connect to server. Please check your internet connection.";
            } else if (err.response) {
                // Server responded with error status
                const status = err.response.status;
                const responseMessage = (err.response.data && err.response.data.message) ? err.response.data.message : null;
                
                if (status === 503 || status === 504) {
                    errorMsg = responseMessage || "Database connection issue. Please try again in a moment.";
                } else if (status === 500) {
                    errorMsg = "Server error. Please try again later.";
                } else if (responseMessage) {
                    errorMsg = responseMessage;
                } else {
                    errorMsg = `Error: ${status}`;
                }
            } else if (err.request) {
                // Request was made but no response received
                errorMsg = "No response from server. Please check your connection and try again.";
            }
            
            setAuthError(errorMsg);
        } finally {
            setAuthLoading(false);
        }
    };

    const handleGuestCheckout = () => {
        setRequireLogin(false);
        setCurrentStep(2);
    };



    const goToStep = (step) => {
        if (step <= currentStep) {
            setCurrentStep(step);
            // Reset validation errors when going back
            setAuthError("");
        }
    };

    const canGoToStep = (step) => {
        // If user is logged in and trying to go to step 1, prevent it
        if (step === 1 && isLoggedIn) {
            return false;
        }
        return step <= currentStep;
    };

    const validatePhoneNumber = (phone) => {
        const phoneRegex = /^\d{10}$/;
        return phoneRegex.test(phone);
    };

    const getFullPhoneNumber = () => {
        return countryCode + contactNumber;
    };

    const saveContactInfo = async () => {
        try {
            const contactData = {
                email: userEmail,
                contactNumber: getFullPhoneNumber(),
                userId: (isLoggedIn && userData) ? userData._id : null
            };
            
            // Save to backend
            await axios.post(
                API_ENDPOINTS.STORE.SAVE_CONTACT_INFO,
                contactData,
                { withCredentials: true }
            );
            
        } catch (error) {
            console.error("Error saving contact info:", error);
            // Continue with checkout even if save fails
        }
    };

    const saveAddressInfo = async () => {
        try {
            const addressData = {
                shippingAddress: billingAddress,
                billingAddress: billingAddress,
                userId: (isLoggedIn && userData) ? userData._id : null
            };
            
            // Save to backend
            await axios.post(
                API_ENDPOINTS.STORE.SAVE_ADDRESS_INFO,
                addressData,
                { withCredentials: true }
            );
            
        } catch (error) {
            console.error("Error saving address info:", error);
            // Continue with checkout even if save fails
        }
    };

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        if (userEmail.trim() && (!contactNumber || validatePhoneNumber(contactNumber))) {
            setStep2Loading(true);
            try {
            // Save contact info before proceeding
            await saveContactInfo();
            setCurrentStep(3);
            } finally {
                setStep2Loading(false);
            }
        }
    };

    const handleAddressSubmit = async (e) => {
        e.preventDefault();
        if (billingAddress.name && billingAddress.street && billingAddress.city && billingAddress.state && billingAddress.zip) {
            setStep3Loading(true);
            try {
            // Save address info before proceeding
            await saveAddressInfo();
            setCurrentStep(4);
            } finally {
                setStep3Loading(false);
            }
        }
    };

    const saveOrderData = async (orderData) => {
        try {
            await axios.post(
                API_ENDPOINTS.STORE.SAVE_ORDER_DATA,
                orderData,
                { withCredentials: true }
            );
            
        } catch (error) {
            console.error("Error saving order data:", error);
            // Continue with payment even if save fails
        }
    };

    const handlePayment = async () => {
        setLoading(true);
        
        try {
            // Prepare order data for payment
            const orderData = {
                userId: (isLoggedIn && userData && userData._id) ? userData._id : null,
                email: userEmail,
                contactNumber: getFullPhoneNumber() || "+91-9876543210",
                shippingAddress: billingAddress,
                billingAddress: billingAddress,
                products: cartItems.map(item => ({
                    productId: item.productId || item.id || item._id, // Use productId if available, fallback to id then _id
                    title: item.title,
                    productType: item.productType || 'physical',
                    variants: item.variants || {},
                    quantity: item.quantity,
                    price: item.price,
                    subtotal: item.price * item.quantity
                })),
                totalAmount: calculateTotal(),
                currency: (cartItems[0] && cartItems[0].currency) || 'INR',
                notes: `Order placed via checkout.`,
                discountDetails: appliedCoupons.map(c => {
                    const isPercent = c.discountType === 'PERCENT' || c.couponType === true;
                    
                    let val = 0;
                    if (isPercent) {
                        val = c.discountValue || c.offerValue || 0;
                    } else {
                        if (c.discountByCountry && c.discountByCountry.length > 0) {
                            const found = c.discountByCountry.find(country => country.country === selectedCountry);
                            val = found ? found.amount : c.discountByCountry[0].amount;
                        } else {
                            val = c.offerValue || 0;
                        }
                    }
                    
                    return {
                        couponCode: c.code,
                        discountType: isPercent ? 'PERCENT' : 'FIXED',
                        discountValue: val,
                        amountOff: 0 // Calculated on backend or implied
                    };
                })
            };

            // Save order data to backend
            await saveOrderData(orderData);

            // Initiate Razorpay payment
            await paymentService.initiatePayment(orderData);
            
            // Note: The payment service will handle the redirect to success page
            // and cart clearing after successful payment
            
        } catch (error) {
            console.error('Error initiating payment:', error);
            setLoading(false);
            alert('Failed to initiate payment. Please try again.');
        }
    };

    const handleFreeOrder = async () => {
        setLoading(true);
        try {
            const orderData = {
                userId: (isLoggedIn && userData) ? userData._id : null,
                email: userEmail,
                contactNumber: getFullPhoneNumber() || "+91-9876543210",
                shippingAddress: billingAddress,
                billingAddress: billingAddress,
                products: cartItems.map(item => ({
                    productId: item.productId || item.id,
                    title: item.title,
                    productType: item.productType || 'physical',
                    variants: item.variants || {},
                    quantity: item.quantity,
                    price: item.price,
                    subtotal: item.price * item.quantity
                })),
                totalAmount: 0,
                currency: (cartItems[0] && cartItems[0].currency) || 'INR',
                notes: `Free order. ${appliedCoupons.length > 0 ? `Coupons: ${appliedCoupons.map(c => c.code).join(', ')}` : ''}`
            };

            const response = await fetch(API_ENDPOINTS.PAYMENT.FREE_ORDER, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(orderData)
            });

            const rawText = await response.text();
            const trimmed = rawText ? rawText.trim() : '';
            if (!trimmed || trimmed === 'undefined' || trimmed === 'null') {
                throw new Error('Server returned empty response. Please try again.');
            }
            const result = JSON.parse(trimmed);

            if (!result.success) {
                throw new Error(result.message || 'Failed to complete free order');
            }

            // Clear cart and coupons
            clearCart();

            // Redirect to success page
            window.location.href = `/order-success?orderId=${result.data.orderId}&paymentId=FREE`;
        } catch (error) {
            console.error('Error completing free order:', error);
            setLoading(false);
            alert('Failed to complete order. Please try again.');
        }
    };

    const renderStep1 = () => (
        <div className="checkout-step rounded-[12px] bg-white p-[30px] max-[480px]:p-[20px]">
            <h2>Step 1: Account</h2>
            
            {isLoggedIn && userData ? (
                <div className="already-logged-in px-[20px] py-[30px] text-center">
                    <div className="user-info">
                        <h3>Welcome back, {userData.name || userData.email}!</h3>
                        <p>You are already logged in and can proceed to the next step.</p>
                        <div className="user-details mb-[25px] flex flex-col gap-[8px] rounded-[8px] bg-[#f8f9fa] p-[15px]">
                            <span><strong>Email:</strong> {userData.email}</span>
                            {userData.name && <span><strong>Name:</strong> {userData.name}</span>}
                        </div>
                    </div>
                    <button 
                        onClick={() => setCurrentStep(2)} 
                        className="continue-btn rounded-[8px] border-0 bg-slider-color px-[24px] py-[12px] text-[1rem] font-[600] text-bg transition-all duration-300 hover:-translate-y-[1px] hover:bg-post-heading"
                        disabled={false}
                    >
                        Continue to Contact Information
                    </button>
                </div>
            ) : (
                <>
                    <div className="login-option mb-[25px]">
                        <label className="flex cursor-pointer items-center gap-[10px] font-[500] text-text">
                            <input
                                type="checkbox"
                                checked={requireLogin}
                                onChange={(e) => setRequireLogin(e.target.checked)}
                                className="h-[18px] w-[18px] min-h-[18px] min-w-[18px] accent-slider-color"
                            />
                            Login to continue purchase (recommended)
                        </label>
                    </div>
                    
                    {requireLogin ? (
                        <div className="auth-section mb-[20px]">
                            {!emailChecked ? (
                                <div className="email-check-section mb-[20px]">
                                    <div className="form-group mb-[20px]">
                                        <label>Email Address:</label>
                                        <input
                                            type="email"
                                            value={userEmail}
                                            onChange={(e) => setUserEmail(e.target.value)}
                                            placeholder="Enter your email"
                                            required
                                            autoComplete="email"
                                            className="w-full rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                                        />
                                    </div>
                                    <button 
                                        onClick={checkEmailExists} 
                                        disabled={!userEmail.trim() || authLoading}
                                        className={`check-email-btn mt-[15px] w-full rounded-[8px] border-0 bg-slider-color px-[24px] py-[12px] text-[1rem] font-[600] text-bg transition-all duration-300 hover:-translate-y-[1px] hover:bg-post-heading disabled:cursor-not-allowed disabled:opacity-60 ${authLoading ? 'button-loading light-spinner' : ''}`}
                                    >
                                        {authLoading ? "Checking..." : "Continue"}
                                    </button>
                                    {authError && <div className="auth-error mt-[15px] rounded-[6px] border border-[#f5c6cb] bg-[#f8d7da] p-[10px] text-center text-[#dc3545]">{authError}</div>}
                                </div>
                            ) : (
                                <div className="password-section mt-[20px]">
                                    <div className="email-display mb-[20px] flex items-center justify-between rounded-[8px] bg-[#f8f9fa] px-[16px] py-[12px]">
                                        <span>Email: {userEmail}</span>
                                        <button 
                                            className="edit-email-btn rounded-[6px] border border-[#6c757d] px-[12px] py-[6px] text-[0.9rem] text-[#6c757d] transition-all duration-300 hover:bg-[#6c757d] hover:text-white"
                                            onClick={() => setEmailChecked(false)}
                                        >
                                            Edit
                                        </button>
                                    </div>
                                    <form onSubmit={handleAuthSubmit}>
                                        <div className="form-group mb-[20px]">
                                            <label>{userExists ? "Password:" : "Create Password:"}</label>
                                            <input
                                                type="password"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                placeholder={userExists ? "Enter your password" : "Create a password"}
                                                required
                                                autoComplete={userExists ? "current-password" : "new-password"}
                                                className="w-full rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                                            />
                                        </div>
                                        {!userExists && (
                                            <div className="form-group mb-[20px]">
                                                <label>Full Name:</label>
                                                <input
                                                    type="text"
                                                    value={billingAddress.name}
                                                    onChange={(e) => setBillingAddress({...billingAddress, name: e.target.value})}
                                                    placeholder="Enter your full name"
                                                    required
                                                    className="w-full rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                                                />
                                            </div>
                                        )}
                                        <button 
                                            type="submit" 
                                            disabled={!password.trim() || authLoading}
                                            className={`auth-submit-btn mt-[15px] w-full rounded-[8px] border-0 bg-[#28a745] px-[24px] py-[12px] text-[1rem] font-[600] text-white transition-all duration-300 hover:-translate-y-[1px] hover:bg-[#218838] disabled:cursor-not-allowed disabled:opacity-60 ${authLoading ? 'button-loading light-spinner' : ''}`}
                                        >
                                            {authLoading ? "Processing..." : (userExists ? "Login" : "Register")}
                                        </button>
                                    </form>
                                    {authError && <div className="auth-error mt-[15px] rounded-[6px] border border-[#f5c6cb] bg-[#f8d7da] p-[10px] text-center text-[#dc3545]">{authError}</div>}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="guest-checkout rounded-[8px] bg-[#f8f9fa] p-[20px] text-center">
                            <p>You can continue as a guest, but you'll need to provide your email for order updates.</p>
                            <button 
                                onClick={handleGuestCheckout}
                                className="guest-checkout-btn rounded-[8px] border-0 bg-[#28a745] px-[25px] py-[12px] text-[1em] font-[600] text-white transition-all duration-300 hover:bg-[#218838]"
                            >
                                Continue as Guest
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );

    const renderStep2 = () => (
        <div className="checkout-step rounded-[12px] bg-white p-[30px] max-[480px]:p-[20px]">
            <h2>Step 2: Contact Information</h2>
            <form onSubmit={handleEmailSubmit} className="email-form">
                <div className="form-group mb-[20px]">
                    <label>Email Address:</label>
                    <input
                        type="email"
                        value={userEmail}
                        onChange={(e) => setUserEmail(e.target.value)}
                        required
                        placeholder="Enter your email for order updates"
                        className="w-full rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                    />
                    <small>We'll send order confirmation and tracking details to this email</small>
                </div>
                <div className="form-group mb-[20px]">
                    <label>Contact Number:</label>
                    <div className="phone-input-group flex items-center gap-[10px]">
                        <input
                            type="text"
                            value={countryCode}
                            onChange={(e) => setCountryCode(e.target.value)}
                            placeholder="+91"
                            className="country-code-input !w-[80px] text-center font-[600] text-[#666] rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                        />
                        <input
                            type="tel"
                            value={contactNumber}
                            onChange={(e) => setContactNumber(e.target.value)}
                            placeholder="9876543210"
                            className={`phone-input flex-1 rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none ${contactNumber && !validatePhoneNumber(contactNumber) ? "error border-[#dc3545]" : ""}`}
                        />
                    </div>
                    <small>For delivery updates and support</small>
                    {contactNumber && !validatePhoneNumber(contactNumber) && (
                        <div className="validation-error mt-[5px] text-[0.85rem] text-[#dc3545]">Please enter a valid 10-digit phone number</div>
                    )}
                </div>
                <button 
                    type="submit"
                    disabled={step2Loading}
                    className={`mt-[10px] w-full rounded-[8px] border-0 bg-slider-color px-[25px] py-[12px] text-[1em] font-[600] text-bg transition-all duration-300 hover:-translate-y-[2px] hover:bg-post-heading disabled:cursor-not-allowed disabled:opacity-60 ${step2Loading ? 'button-loading light-spinner' : ''}`}
                >
                    {step2Loading ? 'Loading...' : 'Continue'}
                </button>
            </form>
        </div>
    );

    const renderStep3 = () => (
        <div className="checkout-step rounded-[12px] bg-white p-[30px] max-[480px]:p-[20px]">
            <h2>Step 3: Billing Address</h2>
            <form onSubmit={handleAddressSubmit} className="address-form">
                <div className="form-group mb-[20px]">
                    <label>Full Name:</label>
                    <input
                        type="text"
                        value={billingAddress.name}
                        onChange={(e) => setBillingAddress({...billingAddress, name: e.target.value})}
                        required
                        placeholder="Enter your full name"
                        className="w-full rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                    />
                </div>
                <div className="form-group mb-[20px]">
                    <label>Street Address:</label>
                    <input
                        type="text"
                        value={billingAddress.street}
                        onChange={(e) => setBillingAddress({...billingAddress, street: e.target.value})}
                        required
                        placeholder="Enter your street address"
                        className="w-full rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                    />
                </div>
                <div className="form-row grid grid-cols-2 gap-[20px] max-[767px]:grid-cols-1 max-[767px]:gap-[15px]">
                    <div className="form-group mb-[20px]">
                        <label>City:</label>
                        <input
                            type="text"
                            value={billingAddress.city}
                            onChange={(e) => setBillingAddress({...billingAddress, city: e.target.value})}
                            required
                            placeholder="City"
                            className="w-full rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                        />
                    </div>
                    <div className="form-group mb-[20px]">
                        <label>State:</label>
                        <input
                            type="text"
                            value={billingAddress.state}
                            onChange={(e) => setBillingAddress({...billingAddress, state: e.target.value})}
                            required
                            placeholder="State"
                            className="w-full rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                        />
                    </div>
                </div>
                <div className="form-row grid grid-cols-2 gap-[20px] max-[767px]:grid-cols-1 max-[767px]:gap-[15px]">
                    <div className="form-group mb-[20px]">
                        <label>ZIP Code:</label>
                        <input
                            type="text"
                            value={billingAddress.zip}
                            onChange={(e) => setBillingAddress({...billingAddress, zip: e.target.value})}
                            required
                            placeholder="ZIP Code"
                            className="w-full rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                        />
                    </div>
                    <div className="form-group mb-[20px]">
                        <label>Country:</label>
                        <select
                            value={billingAddress.country}
                            onChange={(e) => setBillingAddress({...billingAddress, country: e.target.value})}
                            required
                            className="w-full rounded-[8px] border border-[#e9ecef] px-[15px] py-[12px] text-[1em] transition-colors duration-300 focus:border-slider-color focus:outline-none"
                        >
                            <option value="">Select Country</option>
                            {regions && regions.length > 0 ? (
                                regions.map((region) => (
                                    <option key={region.country} value={region.name || region.country}>
                                        {region.name || region.country}
                                    </option>
                                ))
                            ) : (
                                <>
                                    <option value="India">India</option>
                                    <option value="United States">United States</option>
                                </>
                            )}
                        </select>
                    </div>
                </div>
                <button 
                    type="submit"
                    disabled={step3Loading}
                    className={`mt-[10px] w-full rounded-[8px] border-0 bg-slider-color px-[25px] py-[12px] text-[1em] font-[600] text-bg transition-all duration-300 hover:-translate-y-[2px] hover:bg-post-heading disabled:cursor-not-allowed disabled:opacity-60 ${step3Loading ? 'button-loading light-spinner' : ''}`}
                >
                    {step3Loading ? 'Loading...' : 'Continue'}
                </button>
            </form>
        </div>
    );

    const renderStep4 = () => (
        <div className="checkout-step rounded-[12px] bg-white p-[30px] max-[480px]:p-[20px]">
            <h2>Step 4: Payment</h2>
            <div className="order-summary mb-[25px] rounded-[8px] bg-[#f8f9fa] p-[20px]">
                <h3>Order Summary</h3>
                {cartItems.map((item) => (
                    <div key={item.id} className="order-item flex items-start justify-between py-[15px] max-[767px]:flex-col max-[767px]:gap-[10px]">
                        <div className="item-details">
                            <h4>{item.title}</h4>
                            {item.variants && Object.keys(item.variants).length > 0 && (
                                <div className="item-variants mb-[5px]">
                                    {Object.entries(item.variants).map(([key, value]) => (
                                        <span key={key} className="variant-tag mb-[3px] mr-[5px] inline-block rounded-[12px] bg-[#e9ecef] px-[8px] py-[2px] text-[0.8em] text-[#666]">
                                            {key}: {value}
                                        </span>
                                    ))}
                                </div>
                            )}
                            <p>Quantity: {item.quantity}</p>
                        </div>
                        <div className="item-price self-end text-[1.1em] font-[600] text-post-heading">
                            {item.currencySymbol || '₹'}{(item.price * item.quantity).toLocaleString()}
                        </div>
                    </div>
                ))}
                <div className="summary-details">
                    <div className="summary-row flex items-center justify-between py-[6px]">
                        <span>Subtotal:</span>
                        <span>{(cartItems[0] && cartItems[0].currencySymbol) || '₹'}{calculateSubtotal().toLocaleString()}</span>
                    </div>
                    {appliedCoupons.length > 0 && (
                        <div className="summary-row flex items-center justify-between py-[6px]">
                            <span>Discount:</span>
                            <span style={{ color: 'green' }}>-{(cartItems[0] && cartItems[0].currencySymbol) || '₹'}{Math.round(calculateDiscount()).toLocaleString()}</span>
                        </div>
                    )}
                    <div className="summary-row flex items-center justify-between py-[6px]">
                        <span>Shipping:</span>
                        <span>Free</span>
                    </div>
                    <div className="summary-total mt-[8px] flex items-center justify-between border-t border-[#ddd] pt-[10px] text-[1.1em]">
                        <strong>Total:</strong>
                        <strong>{(cartItems[0] && cartItems[0].currencySymbol) || '₹'}{Math.round(calculateTotal()).toLocaleString()}</strong>
                    </div>
                </div>
            </div>
            
            {(() => {
                const total = calculateTotal();
                const allDigital = cartItems.every(item => item.productType === 'digital');
                const hasPhysical = cartItems.some(item => item.productType !== 'digital');

                // Free order: only allowed if ALL items are digital
                if (total <= 0 && allDigital) {
                    return (
                        <button 
                            onClick={handleFreeOrder} 
                            disabled={loading}
                            className={`payment-btn free-order-btn w-full rounded-[8px] border-0 bg-[#28a745] p-[15px] text-[1.1em] text-white transition-all duration-300 hover:-translate-y-[2px] hover:bg-[#218838] disabled:cursor-not-allowed disabled:opacity-60 ${loading ? 'button-loading light-spinner' : ''}`}
                        >
                            {loading ? "Processing..." : "Complete Purchase"}
                        </button>
                    );
                }

                // Physical products with total < ₹1: show warning
                if (hasPhysical && total < 1) {
                    return (
                        <div className="payment-warning mb-[20px] rounded-[8px] border border-[#ffeeba] bg-[#fff3cd] p-[15px] text-center text-[#856404]">
                            <p>⚠️ Minimum order amount for physical products is ₹1. Please adjust your cart or remove the discount to proceed.</p>
                            <button className="payment-btn w-full rounded-[8px] border-0 bg-[#28a745] p-[15px] text-[1.1em] text-white opacity-60" disabled>
                                Pay ₹{Math.round(total).toLocaleString()}
                            </button>
                        </div>
                    );
                }

                // Normal payment flow
                return (
                    <>
                        <div className="payment-method mb-[25px]">
                            <h3>Select Payment Method</h3>
                            <div className="payment-options flex flex-col gap-[12px]">
                                <label className="flex cursor-pointer items-center gap-[10px] rounded-[8px] bg-[#f8f9fa] px-[15px] py-[12px] transition-all duration-300 hover:bg-[#e9ecef]">
                                    <input
                                        type="radio"
                                        value="UPI"
                                        checked={paymentMethod === "UPI"}
                                        onChange={(e) => setPaymentMethod(e.target.value)}
                                        className="h-[18px] w-[18px] min-h-[18px] min-w-[18px] accent-slider-color"
                                    />
                                    UPI
                                </label>
                                <label className="flex cursor-pointer items-center gap-[10px] rounded-[8px] bg-[#f8f9fa] px-[15px] py-[12px] transition-all duration-300 hover:bg-[#e9ecef]">
                                    <input
                                        type="radio"
                                        value="Credit Card"
                                        checked={paymentMethod === "Credit Card"}
                                        onChange={(e) => setPaymentMethod(e.target.value)}
                                        className="h-[18px] w-[18px] min-h-[18px] min-w-[18px] accent-slider-color"
                                    />
                                    Credit Card
                                </label>
                                <label className="flex cursor-pointer items-center gap-[10px] rounded-[8px] bg-[#f8f9fa] px-[15px] py-[12px] transition-all duration-300 hover:bg-[#e9ecef]">
                                    <input
                                        type="radio"
                                        value="Debit Card"
                                        checked={paymentMethod === "Debit Card"}
                                        onChange={(e) => setPaymentMethod(e.target.value)}
                                        className="h-[18px] w-[18px] min-h-[18px] min-w-[18px] accent-slider-color"
                                    />
                                    Debit Card
                                </label>
                            </div>
                        </div>
                        
                        <button 
                            onClick={handlePayment} 
                            disabled={loading}
                            className={`payment-btn w-full rounded-[8px] border-0 bg-[#28a745] p-[15px] text-[1.1em] text-white transition-all duration-300 hover:-translate-y-[2px] hover:bg-[#218838] disabled:cursor-not-allowed disabled:opacity-60 ${loading ? 'button-loading light-spinner' : ''}`}
                        >
                            {loading ? "Processing Payment..." : `Pay ₹${Math.round(total).toLocaleString()}`}
                        </button>
                    </>
                );
            })()}
        </div>
    );

        const renderStepIndicator = () => {
            return (
                <div className="step-indicator relative mb-[40px] flex w-full items-start justify-between p-0">
                    {/* Individual line segments between each step */}
                    <div className={`line-segment ${currentStep > 1 ? 'completed' : ''} absolute top-[20px] z-[1] h-[3px] rounded-[2px] bg-[#e9ecef] transition-all duration-300`} style={{
                        left: '16%',
                        width: '18%'
                    }}></div>
                    <div className={`line-segment ${currentStep > 2 ? 'completed' : ''} absolute top-[20px] z-[1] h-[3px] rounded-[2px] bg-[#e9ecef] transition-all duration-300`} style={{
                        left: '41%',
                        width: '18%'
                    }}></div>
                    <div className={`line-segment ${currentStep > 3 ? 'completed' : ''} absolute top-[20px] z-[1] h-[3px] rounded-[2px] bg-[#e9ecef] transition-all duration-300`} style={{
                        left: '66%',
                        width: '18%'
                    }}></div>
                    
                    <div 
                        className={`step relative m-0 flex min-h-[80px] flex-1 flex-col items-center justify-start p-0 ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''} ${isLoggedIn ? 'disabled' : ''}`}
                        onClick={() => canGoToStep(1) && goToStep(1)}
                    >
                        <span className="step-number relative z-[3] mb-[12px] mt-0 flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full bg-[#e9ecef] p-0 text-[18px] font-[700] text-[#333]">
                            {currentStep > 1 ? '✓' : '1'}
                        </span>
                        <span className="step-label m-0 block shrink-0 whitespace-nowrap p-0 text-center text-[14px] font-[600] leading-[1.2] text-[#555]">Account</span>
                    </div>
                    <div 
                        className={`step relative m-0 flex min-h-[80px] flex-1 flex-col items-center justify-start p-0 ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`}
                        onClick={() => canGoToStep(2) && goToStep(2)}
                    >
                        <span className="step-number relative z-[3] mb-[12px] mt-0 flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full bg-[#e9ecef] p-0 text-[18px] font-[700] text-[#333]">
                            {currentStep > 2 ? '✓' : '2'}
                        </span>
                        <span className="step-label m-0 block shrink-0 whitespace-nowrap p-0 text-center text-[14px] font-[600] leading-[1.2] text-[#555]">Contact</span>
                    </div>
                    <div 
                        className={`step relative m-0 flex min-h-[80px] flex-1 flex-col items-center justify-start p-0 ${currentStep >= 3 ? 'active' : ''} ${currentStep > 3 ? 'completed' : ''}`}
                        onClick={() => canGoToStep(3) && goToStep(3)}
                    >
                        <span className="step-number relative z-[3] mb-[12px] mt-0 flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full bg-[#e9ecef] p-0 text-[18px] font-[700] text-[#333]">
                            {currentStep > 3 ? '✓' : '3'}
                        </span>
                        <span className="step-label m-0 block shrink-0 whitespace-nowrap p-0 text-center text-[14px] font-[600] leading-[1.2] text-[#555]">Address</span>
                    </div>
                    <div 
                        className={`step relative m-0 flex min-h-[80px] flex-1 flex-col items-center justify-start p-0 ${currentStep >= 4 ? 'active' : ''}`}
                        onClick={() => canGoToStep(4) && goToStep(4)}
                    >
                        <span className="step-number relative z-[3] mb-[12px] mt-0 flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full bg-[#e9ecef] p-0 text-[18px] font-[700] text-[#333]">4</span>
                        <span className="step-label m-0 block shrink-0 whitespace-nowrap p-0 text-center text-[14px] font-[600] leading-[1.2] text-[#555]">Payment</span>
                    </div>
                </div>
            );
        };

    if (cartItems.length === 0) {
        return <div className="checkout-empty mx-auto my-[2%] flex min-h-[200px] w-[min(95%,1200px)] items-center justify-center rounded-[12px] bg-bg px-[16px] py-[20px] text-[1rem] text-[#666] shadow-[0_4px_20px_rgba(0,0,0,0.1)]">Loading...</div>;
    }

    return (
        <div className="checkout-container rounded-[15px] bg-bg p-[20px] shadow-[0_4px_20px_rgba(0,0,0,0.1)]">
            <div className="checkout-header mb-[30px] flex items-center justify-between border-b border-transparent pb-[20px] max-[767px]:flex-col max-[767px]:gap-[15px] max-[767px]:text-center">
                <h1>Checkout</h1>
                <button onClick={() => window.history.back()} className="back-to-cart rounded-[8px] border-0 bg-slider-color px-[20px] py-[10px] font-[600] text-bg transition-all duration-300 hover:-translate-y-[2px] hover:bg-post-heading">
                    ← Back
                </button>
            </div>
            
            {renderStepIndicator()}
            
            <div className="checkout-content">
                {currentStep === 1 && renderStep1()}
                {currentStep === 2 && renderStep2()}
                {currentStep === 3 && renderStep3()}
                {currentStep === 4 && renderStep4()}
            </div>
        </div>
    );
}



